import Service, { service } from '@ember/service';
import pht from 'client-portal/utils/persistent-hash-table';

export default class PracticeStorageService extends Service {
  @service currentPractice;

  scopedKey(key) {
    return `${this.currentPractice.get('id')}:${key}`;
  }

  get(key) {
    return pht.get(this.scopedKey(key));
  }

  set(key, value) {
    return pht.set(this.scopedKey(key), value);
  }

  remove(key) {
    return pht.remove(this.scopedKey(key));
  }
}
